<template>
  <div class="viewurl-page">

    <el-breadcrumb style="margin-bottom:30px;" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="first-breadcrumb">{{ $t("SidebarMenu.Menu06") }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/PriceMonitoring/' + $route.params.Id }">{{ defalutbrand }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{topinfo.name}}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="viewurl-topinfo">
      <el-row :gutter="50">
        <el-col :span="8">
          <h1>{{ $t('jgjk.s19') }}</h1>
          <ul class="viewurl-topinfo-ul">
            <li><span>{{ $t('jgjk.s15') }}:</span>{{topinfo.name}}</li>
            <li><span>{{ $t('jgjk.s13') }}:</span>{{topinfo.series}}</li>
            <li><span>{{ $t('jgjk.s14') }}:</span>{{topinfo.model}}</li>
            <li><span>{{ $t('jgjk.s16') }}:</span>{{topinfo.type}}</li>
            <li><span>SKUID:</span>{{topinfo.skuid}}</li>
            <li><span>SKU Code:</span>{{topinfo.sku}}</li>
            <li><span>{{ $t('jgjk.s305') }}:</span>{{topinfo.price}}</li>
          </ul>    
        </el-col>
        <el-col :span="8">
          <div class="dashboard-container">
            <LineChart 
              chartid="line1"
              charttitle="近7天最低价" 
              :chartdata="linechartdata"
              chartheight="140px" 
              :animation="true"
            />
          </div>
        </el-col>
        <el-col :span="8">
          <div class="last7daystrendbox">
            <div class="dashboard-container">
              <ChartBar
                :chartdata="barchartdata"
                :charttitle="$t('append.productdistribution')" 
                chartheight="140px" 
                chartid="chartidbar" />             
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <ViewUrlPageTable />

  </div>
</template>

<script>
import ChartBar from '@/components/Charts/ChartBar.vue'
import LineChart from '@/components/Charts/LineChart.vue'
import ViewUrlPageTable from '@/components/PriceMonitoring/ViewUrlPageTable.vue'
export default {
  components: {
    ChartBar,
    ViewUrlPageTable,
    LineChart
  },
  data(){
    return{
      topinfo:{
        name: '',
        series: '',
        model: '',
        type: '',
        channel: '',
        sku: ''
      },
      barchartdata: [],
      linechartdata: {},
      defalutbrand: ''
    }
  },
  
  mounted(){
    this.getTopInfo()
    this.getPricemonitoring()
    this.getPageTopTrend()
    this.getLowPrice()
  },

  methods: {

    /**
     * 获取品牌
     */
    getPricemonitoring: function(){
      let that = this
      let priceArr = JSON.parse(localStorage.getItem("price")).val
      for(let i=0; i<priceArr.length; i++){
        if(priceArr[i].subid/1 === that.$route.params.Id/1){
          that.defalutbrand = priceArr[i].name
        }
      }
    },

    /**
     * 获取总览信息
     */
    getTopInfo: function(){
      this.topinfo = JSON.parse(localStorage.getItem("viewurl")).val
    },

    /**
     * 获取表头
     */
    getPageTopTrend: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/daily'
      let data = {
        skuid: JSON.parse(localStorage.getItem("viewurl")).val.skuid
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          that.barchartdata = rex.results
          // callback()
        },
        error: function(response) {
          console.log('getPageTop', response)
        }
      })      
    },

    /**
     * 获取最近7天低价
     */
    getLowPrice: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/dailylowestPrice'
      let data = {
        skuid: JSON.parse(localStorage.getItem("viewurl")).val.skuid
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getLowPrice', rex)
          let lineChartDataObj = rex.results
          let x = [];
          let y = [];
          for (var i = 0; i < lineChartDataObj.length; i++) {
              x[i] = that.$moment(lineChartDataObj[i].currentDate).utc().format('MM-DD')
              y[i] = lineChartDataObj[i].price
          }
          that.linechartdata = {
            xAxis: x,
            yAxis: [{
              type: 'line',
              smooth: true,
              data: y
            }]
          }
        },
        error: function(response) {
          console.log('getLowPrice', response)
        }
      })      
    },

  }
}
</script>
